import { RichText } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';
import { TCellTextProps } from '../../../types/index.types';

const TableCellText: FC<TCellTextProps> = (props) => {
  const { index, row, hideCell, fadeIn } = props;

  const data = row.getCellData(index);

  if (!data?.value) return null;
  return (
    <RichText
      field={data}
      editable={true}
      className={`
        rich-text
        model-detail-specification-table__spec 
        model-detail-specification-table__cell-animation
        ${fadeIn ? 'model-detail-specification-table__cell-animation--show-animation' : ''}
        ${hideCell ? 'model-detail-specification-table__cell-animation--hide' : ''}
      `}
    />
  );
};

export default TableCellText;
